<template>
  <div>
    <b-sidebar
      id="sidebar-menu"
      backdrop
      no-header
      text-variant="light"
      bg-variant="dark"
      aria-labelledby="sidebar-menu-title"
      backdrop-variant="dark"
      ref="mainsidebar"
      @shown="shown"
    >
      <template #default>
        <div class="p-3">
          <div class="d-flex align-items-center flex-column justify-spaced">
            <b-avatar class="mb-3 mt-3" size="5rem"
              ><img class="mb-3 mt-3 ml-2" :src="navlogo" style="width: 50px"
            /></b-avatar>
            <b-row>
              <b-col class="colleft"></b-col>
              <b-col class="colcenter">
                <h5 id="sidebar-no-header-title">
                  {{ gtxProfiler_DisplayName }}
                </h5>
              </b-col>
              <b-col class="float-right">
                <b-button
                  variant="danger"
                  class="btn btn-icon"
                  title="Encerrar sessão"
                  v-b-tooltip.hover
                  @click="menuclick('Sair')"
                >
                  <b-icon-power></b-icon-power>
                </b-button>
              </b-col>
            </b-row>
            <div class="divider-menu"></div>
          </div>
          <nav class="mb-3">
            <b-nav vertical>
              <b-nav-item
                href="#"
                class="menu"
                :class="
                  m.submenu.length == 0 ? '' : !m.collapsed ? '' : 'menuopen'
                "
                v-for="m of menusguard"
                :key="m.title"
                @click.stop="menuclick(m)"
              >
                <span>
                  <b-icon :icon="m.icon" class="mr-2" />
                  {{ $t(m.title) }}
                </span>
                <span v-if="m.submenu.length > 0">
                  <b-icon-chevron-up
                    v-if="menus.find((f) => f.title == m.title).collapsed"
                    class="float-right"
                  ></b-icon-chevron-up>
                  <b-icon-chevron-down
                    v-else
                    class="float-right"
                  ></b-icon-chevron-down>
                  <b-collapse
                    v-model="menus.find((f) => f.title == m.title).collapsed"
                    :id="`id${m.title}`"
                  >
                    <!-- :title="s.subroute.hint"
                  v-b-tooltip.hover -->
                    <b-nav-item
                      href="#"
                      class="submenu"
                      v-for="s of m.submenu"
                      :key="s.title"
                      @click.stop="menuclick(s)"
                    >
                      <span>
                        <b-icon :icon="s.icon" class="mr-2" />
                        {{ $t(s.title) }}
                      </span>
                      <b-badge
                        variant="secondary"
                        class="float-right btn-icon"
                        :title="s.subroute.hint"
                        v-if="s.subroute"
                        :to="s.subroute.route"
                        @click.stop=""
                        ><b-icon
                          v-if="s.subroute.icon"
                          :icon="s.subroute.icon"
                        ></b-icon
                        >{{ $t(s.subroute.title) }}</b-badge
                      >
                    </b-nav-item>
                  </b-collapse>
                </span>
              </b-nav-item>
            </b-nav>
          </nav>
          <!--
          <pre class="text-light">
            {{ menus }}
          </pre>
          <pre class="text-light">
            {{ menusguard }}
            </pre
            >
          -->
        </div>
      </template>
      <template #footer="{ hide }">
        <div class="mx-3 mb-2">
          <b-button variant="light" block @click="hide"
            ><b-icon-box-arrow-in-left />Fechar</b-button
          >
        </div>
        <div
          style="font-size: 10px"
          class="mb-2 text-muted font-italic text-right mr-2"
        >
          Versão: {{ gtxVersion }}
        </div>
      </template>
    </b-sidebar>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "SideBarComponent",

  props: {
    show: Boolean,
    default() {
      return false;
    },
  },
  data() {
    return {
      navlogo: require("../assets/K1_Logo.png"),
      menus: [
        {
          title: "Home",
          icon: "house",
          route: "/",
          roles: [],
          rolesdeny: [],
        },
        // {
        //   title: "Clientes",
        //   icon: "handbag",
        //   route: "/clientesdashboard",
        //   roles: ["FRANQUIASROLE", "K1CLIENTESROLE"],
        //   rolesdeny: [],
        // },
        {
          title: "Planejados",
          icon: "rulers",
          route: "/planejadosdashboard",
          roles: ["FRANQUIASROLE", "BARTZENROLE"],
          rolesdeny: [],
          submenu: [
            {
              title: "Consumidores",
              icon: "people",
              route: "/planejadosconsumidores",
              roles: [],
              rolesdeny: [],
              subroute: {
                title: "",
                hint: "Novo Consumidor",
                icon: "plus",
                route: "/planejadosconsumidoresfrm",
              },
            },
            {
              title: "Contratos",
              icon: "pen",
              route: "/planejadoscontratos",
              roles: ["FRANQUIASROLE"],
              rolesdeny: [],
              subroute: {
                title: "",
                hint: "Novo Contrato",
                icon: "plus",
                route: "/planejadoscontratosfrm",
              },
            },
            {
              title: "Orçamentos",
              icon: "wallet2",
              route: "/orcamentosbuilderlst",
              roles: ["FRANQUIASROLE", "BARTZENROLE"],
              rolesdeny: [],
              subroute: {
                title: "",
                hint: "Novo Orçamento",
                icon: "plus",
                route: "/orcamentosbuilderfrm",
              },
            },
          ],
        },
        {
          title: "Cadastros",
          icon: "inboxes",
          route: "/lancamentos",
          roles: ["BARTZENROLE", "FRANQUIASROLE"],
          rolesdeny: [],
          submenu: [
            {
              title: "Consumidor",
              icon: "person-plus",
              route: "/planejadosconsumidoresfrm",
              roles: [],
              rolesdeny: [],
            },
            {
              title: "Contrato",
              icon: "pen",
              route: "/planejadoscontratosfrm",
              roles: ["FRANQUIASROLE"],
              rolesdeny: [],
            },
            {
              title: "Orçamento",
              icon: "wallet2",
              route: "/orcamentosbuilderfrm",
              roles: [],
              rolesdeny: [],
            },
          ],
        },
        {
          title: "Logística",
          icon: "truck",
          route: "/logistica",
          roles: ["TRANSPORTADORASROLE", "BARTZENROLE", "FRANQUIASROLE"],
          rolesdeny: [],
          submenu: [
            {
              title: "Romaneios",
              icon: "ui-checks",
              route: "/Romaneios",
              roles: [],
              rolesdeny: [],
            },
            {
              title: "Conferências de Notas",
              icon: "printer",
              route: "/notasfiscais?coletar=true",
              roles: [],
              rolesdeny: [],
            },
          ],
        },
        {
          title: "Financeiro",
          icon: "currency-dollar",
          roles: ["BARTZENROLE", "FRANQUIASROLE"],
          rolesdeny: [],
          submenu: [
            {
              title: "Notas Fiscais",
              icon: "printer",
              route: "/notasfiscais",
              roles: [],
              rolesdeny: [],
            },
            {
              title: "Pedidos",
              icon: "cash-coin",
              route: "/clientespedidos",
              roles: [],
              rolesdeny: [],
              subroute: {
                title: "",
                hint: "Dashboard Pedidos",
                icon: "columns-gap",
                route: "/clientesdashboardstatus",
              },
            },
            {
              title: "Depósitos",
              icon: "bank2",
              route: "/depositos",
              roles: [],
              rolesdeny: [],
              subroute: {
                title: "",
                hint: "Dashboard Depósitos",
                icon: "columns-gap",
                route: "/depositosdashboard",
              },
            },
          ],
        },
        {
          title: "Colaboradores",
          icon: "person-badge",
          route: "/despesas",
          roles: ["K1ERPROLE"],
          rolesdeny: [],
        },
        {
          title: "Produção",
          icon: "tools",
          route: "/producao",
          roles: ["K1ERPROLE"],
          rolesdeny: [],
          submenu: [
            {
              title: "Lotes",
              icon: "box-seam",
              route: "/lotes",
              roles: ["K1ERPROLE"],
              rolesdeny: [],
            },
          ],
        },
        {
          title: "Relatórios",
          icon: "journal-text",
          roles: ["FRANQUIASROLE", "BARTZENROLE"],
          rolesdeny: [],
          submenu: [
            {
              title: "Metas",
              icon: "pie-chart",
              route: "/metaslojistas",
              roles: [],
              rolesdeny: [],
            },
            {
              title: "Consultas",
              icon: "search",
              route: "/consultas",
              roles: [],
              rolesdeny: [],
            },
          ],
        },
        {
          title: "Fornecedores",
          icon: "box-seam",
          route: "/fornecedores",
          roles: ["FORNECFORMULARIOSAVALIACAOROLE"],
          rolesdeny: [],
          submenu: [
            {
              title: "Dashboard",
              icon: "columns-gap",
              route: "/fornecedores",
              roles: [],
              rolesdeny: [],
            },
            {
              title: "Pré-Cadastro",
              icon: "box-seam",
              route: "/comprasfornecprecadastro",
              roles: [],
              rolesdeny: [],
            },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapGetters("profilerStore", [
      "gtxProfilerRoles",
      "gtxProfiler_DisplayName",
    ]),
    ...mapGetters(["gtxVersion"]),
    menusguard() {
      //return this.menus;
      return this.menus
        .filter((m) => this.filtrorole(m))
        .map((m) => {
          return {
            ...m,
            ...{ collapsed: false },
            ...{
              submenu: m.submenu
                ? m.submenu.filter((s) => this.filtrorole(s))
                : [],
            },
          };
        });
    },
  },
  methods: {
    ...mapActions("profilerStore", ["actProfilerGet"]),
    shown() {
      if (this.$cookies.get("token") && this.$cookies.get("token") !== "") {
        this.actProfilerGet();
      }
    },
    menuclick(menu) {
      // console.log("menuclick:", menu);
      // console.log("menuclick:", {
      //   path: menu.route,
      //   params: { ...menu.params },
      // });
      if (typeof menu == "object") {
        const lmenu = this.menus.find((m) => m.title == menu.title);
        if (!menu.submenu || (menu.submenu && menu.submenu.length == 0)) {
          if (this.$route.path !== menu.route)
            if (menu.routename) {
              this.$router.push({
                name: menu.routename,
                params: { ...menu.params },
              });
            } else {
              this.$router.push({
                path: menu.route,
                params: { ...menu.params },
              });
            }
        } else {
          lmenu.collapsed = !lmenu.collapsed;
          //this.$root.$emit("bv::toggle::collapse", `id${menu.title}`);
        }
      }
      this.$emit("menuclick", menu);

      if (menu == "Sair") this.closemainsidebar();
    },
    closemainsidebar() {
      this.$refs.mainsidebar.hide();
    },
    filtrorole(m) {
      return this.gtxProfilerRoles.length > 0
        ? m.roles.length == 0 ||
            m.roles.some(
              (role) =>
                this.gtxProfilerRoles.some((r) => r.Role === role) &&
                !m.rolesdeny.some((role) =>
                  this.gtxProfilerRoles.some((r) => r.Role === role)
                )
            )
        : true;

      return this.gtxProfilerRoles.length > 0
        ? this.gtxProfilerRoles
            .map((p) => p.Role)
            .some((r) => m.roles.includes(r) || m.roles.length == 0) &&
            this.gtxProfilerRoles
              .map((p) => p.Role)
              .some((r) => !m.rolesdeny.includes(r) || m.rolesdeny.length == 0)
        : true;
    },
  },
};
</script>

<style scoped>
.nav-item > .nav-link {
  color: #fff;
  text-align: left;
}
.nav-item > .nav-link:hover {
  color: #ccc;
}
.H4 {
  text-align: center;
}
.divider-menu {
  border: 1px solid #fff;
  width: 100%;
}

.menu:hover:first-child {
  border-top-right-radius: 0;
  border-top-left-radius: 0;
}
.menuopen {
  background-color: dimgray;
  border-radius: 5px;
}
.menu:hover {
  background-color: dimgray;
  border-radius: 5px;
}
.submenu {
  font-size: 12px;
}
.submenu:hover {
  background-color: rgb(72, 81, 86);
  border-radius: 5px;
}
.submenu:first-child {
  margin-top: 10px;
}
</style>
